import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiCity\ChangeFavoriteStatusWikiCityController::__invoke
* @see app/Http/Controllers/WikiCity/ChangeFavoriteStatusWikiCityController.php
* @route '/api/city/change-favorite-city/{city}'
*/
const ChangeFavoriteStatusWikiCityController = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ChangeFavoriteStatusWikiCityController.url(args, options),
    method: 'put',
})

ChangeFavoriteStatusWikiCityController.definition = {
    methods: ["put"],
    url: '/api/city/change-favorite-city/{city}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\WikiCity\ChangeFavoriteStatusWikiCityController::__invoke
* @see app/Http/Controllers/WikiCity/ChangeFavoriteStatusWikiCityController.php
* @route '/api/city/change-favorite-city/{city}'
*/
ChangeFavoriteStatusWikiCityController.url = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { city: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { city: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            city: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        city: typeof args.city === 'object'
        ? args.city.id
        : args.city,
    }

    return ChangeFavoriteStatusWikiCityController.definition.url
            .replace('{city}', parsedArgs.city.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiCity\ChangeFavoriteStatusWikiCityController::__invoke
* @see app/Http/Controllers/WikiCity/ChangeFavoriteStatusWikiCityController.php
* @route '/api/city/change-favorite-city/{city}'
*/
ChangeFavoriteStatusWikiCityController.put = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ChangeFavoriteStatusWikiCityController.url(args, options),
    method: 'put',
})

export default ChangeFavoriteStatusWikiCityController